import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sitemap/SimpleSitemap.js");
